<script setup lang="ts">
import IOHeader from "@/components/io/io-header/IOHeader.vue";
import IOHero from "@/components/io/io-hero/IOHero.vue";
import StripeMegaMenuV1 from "@/components/StripeMegaMenuV1.vue";
import IOMobileHeader from "@/components/io/io/header/IOMobileHeader.vue";
import HeaderBranding from "@/components/io/io/header/HeaderBranding.vue";
import HeaderBrandingInverse from "@/components/io/io/header/HeaderBrandingInverse.vue";
import TheFooter from "@/components/TheFooter.vue";
import Button from "@/components/Button.vue";

useHead({
  script: [
    {
      src: 'https://cdn.jsdelivr.net/npm/@lottiefiles/lottie-player',
      type: 'text/javascript',
      defer: true,
    }
  ],
})

import { mobileNavigationItems } from '@/io'
const router = useRouter()
const { loading } = useLoadingMounted()

useHero()

useGlobalContent()

</script>

<template>
<div class="canvas-full layout-default" :class="{ loading }">

  <IOHeader primaryW="max-w-96% w-full mx-auto flex h-full">
      <template #before>
        <div class="sec-header-bg-gradiant" />
      </template>
      <template #primary>
        <Column class="sec-branding w-250px h-full" w="w-full h-full">
          <HeaderBranding />
        </Column>
        <Column class="flex-1 sec-navigation h-full" w="flex g-0.55 justify-center h-full">
          <!-- <IOMegaMenu /> -->
          <!-- <AtomicMenu /> -->
          <StripeMegaMenuV1 />
          <!-- <StripeMegaMenuV1 /> -->
        </Column>
        <Column class="sec-actions " w="h-full flex g-0.55 items-center">
          <AActions class="min-w-300px" w="flex items-center justify-end">
            <!-- <Button @click="router.push('/contact-us')" class="mpd btn-assessment" outlined>Free Assessment</Button> -->
            <Button @click="router.push('/contact-us')" class="mpd btn-contact" outlined>Contact Us</Button>
          </AActions>
        </Column>
      </template>

      <template #mobile>
        <IOMobileHeader :menu="mobileNavigationItems">
          <template #flyoutheader>
            <HeaderBrandingInverse :disable-fixed="true" />
          </template>
          <template #close-btn-icon>
            <i class="flex i i-mdi:close" />
          </template>
        </IOMobileHeader>
      </template>
  </IOHeader>

  <IOHero />

  <main class="sec-primary">
    <slot />
  </main>

  <TheFooter />

  <div id="mpd" />
  <div id="io" />

</div>
</template>

<style lang="scss">




// Global Colour Defaults
body {

  h1,
  h2,
  h3,
  h3,
  h4,
  h5,
  h6 {
    // color: var(--primaryTextColor);
    color: var(--primaryTitleColor);
  }

  .title {
    >div {
      // color: var(--bluegray);
      color: var(--primaryTitleColor);
    }
  }

  p {
    color: var(--primaryTextColor);
  }
}

/* Webkit-based browsers (Chrome, Safari, Edge) */
::-webkit-scrollbar {
  width: 8px;
  /* Width of the entire scrollbar */
  height: 8px;
  /* Height of the entire scrollbar */
}

::-webkit-scrollbar-track {
  background: var(--base-100);
  /* Background of the scrollbar track */
  border-radius: 10px;
  /* Rounded corners for the track */
}

::-webkit-scrollbar-thumb {
  background-color: var(--base-500);
  /* Color of the scrollbar thumb */
  border-radius: 10px;
  /* Rounded corners for the thumb */
  border: 3px solid var(--base-100);
  /* Adds a border around the thumb */
}

::-webkit-scrollbar-thumb:hover {
  background-color: #555;
  /* Color of the scrollbar thumb on hover */
}


/* Firefox */
* {
  scrollbar-width: thin;
  /* Thin scrollbar width */
  scrollbar-color: var(--base-500) var(--base-100);
  /* Color of the scrollbar thumb and track */
}

/* Optional: Customize the scrollbar thumb and track further */
*::-webkit-scrollbar-track {
  background: var(--base-100);
  /* Background of the scrollbar track */
}

*::-webkit-scrollbar-thumb {
  background-color: var(--base-500);
  /* Color of the scrollbar thumb */
  border-radius: 10px;
  /* Rounded corners for the thumb */
  border: 3px solid var(--base-100);
  /* Adds a border around the thumb */
}

*::-webkit-scrollbar-thumb:hover {
  background-color: #555;
  /* Color of the scrollbar thumb on hover */
}



// @import '@/assets/scss/animation.scss';

// Custom Theme CSS global vars

// @import '../assets/scss/pt/themes/mpire/theme.scss';

// SCSS Theme Global CSS Vars

// @import '../assets/scss/pt/themes/mpire/theme-light.scss';
// @import '../assets/scss/pt/themes/mpire/theme-dark.scss';

// SCSS Variables for Light and Dark specific to the Dashboard env

// @import '../assets/scss/env/dashboard/dashboard-light.scss';
// @import '../assets/scss/env/dashboard/dashboard-dark.scss';



// BOUNCED DOWN SYLES FOR LOADING

// Bounced down scale

html {

  // Mobile
  @include mq($until: txs) {
    font-size: 106.25%;
    --fs: 1.0625rem;
    --lh: 1.5;
    --s: 1.2;
    --fs--5: 0.40187757201646096rem;
    --gr--5: 1.5rem;
    --fs--45: 0.44023482309764517rem;
    --gr--45: 1.5rem;
    --fs--4: 0.4822530864197532rem;
    --gr--4: 1.5rem;
    --fs--35: 0.5282817877171742rem;
    --gr--35: 1.5rem;
    --fs--3: 0.5787037037037037rem;
    --gr--3: 1.5rem;
    --fs--25: 0.633938145260609rem;
    --gr--25: 1.5rem;
    --fs--2: 0.6944444444444445rem;
    --gr--2: 1.5rem;
    --fs--15: 0.7607257743127307rem;
    --gr--15: 1.5rem;
    --fs--1: 0.8333333333333334rem;
    --gr--1: 1.5rem;
    --fs--05: 0.9128709291752769rem;
    --gr--05: 1.5rem;
    --fs-0: 1rem;
    --gr-0: 1.5rem;
    --fs-05: 1.0954451150103321rem;
    --gr-05: 1.5rem;
    --fs-1: 1.2rem;
    --gr-1: 1.5rem;
    --fs-15: 1.3145341380123985rem;
    --gr-15: 1.5rem;
    --fs-2: 1.44rem;
    --gr-2: 1.5rem;
    --fs-25: 1.5774409656148782rem;
    --gr-25: 3rem;
    --fs-3: 1.7279999999999998rem;
    --gr-3: 3rem;
    --fs-35: 1.8929291587378538rem;
    --gr-35: 3rem;
    --fs-4: 2.0736rem;
    --gr-4: 3rem;
    --fs-45: 2.2715149904854246rem;
    --gr-45: 3rem;
    --fs-5: 2.4883199999999994rem;
    --gr-5: 3rem;
    --fs-55: 2.7258179885825093rem;
    --gr-55: 3rem;
    --fs-6: 2.9859839999999993rem;
    --gr-6: 3rem;
    --fs-65: 3.270981586299011rem;
    --gr-65: 4.5rem;
    --fs-7: 3.583180799999999rem;
    --gr-7: 4.5rem;
    --fs-75: 3.9251779035588132rem;
    --gr-75: 4.5rem;
    --fs-8: 4.2998169599999985rem;
    --gr-8: 4.5rem;
    --fs-85: 4.710213484270575rem;
    --gr-85: 6rem;
    --fs-9: 5.1597803519999985rem;
    --gr-9: 6rem;
    --fs-95: 5.65225618112469rem;
    --gr-95: 6rem;
    --fs-10: 6.191736422399997rem;
    --gr-10: 7.5rem;
  }

  // Tablets
  @include mq($from: txs) {
    font-size: 100%;
    --fs: 1rem;
    --lh: 1.6;
    --s: 1.25;
    --fs--5: 0.32767999999999997rem;
    --gr--5: 1.6rem;
    --fs--45: 0.36635737743356556rem;
    --gr--45: 1.6rem;
    --fs--4: 0.40959999999999996rem;
    --gr--4: 1.6rem;
    --fs--35: 0.45794672179195695rem;
    --gr--35: 1.6rem;
    --fs--3: 0.512rem;
    --gr--3: 1.6rem;
    --fs--25: 0.5724334022399462rem;
    --gr--25: 1.6rem;
    --fs--2: 0.64rem;
    --gr--2: 1.6rem;
    --fs--15: 0.7155417527999327rem;
    --gr--15: 1.6rem;
    --fs--1: 0.8rem;
    --gr--1: 1.6rem;
    --fs--05: 0.8944271909999159rem;
    --gr--05: 1.6rem;
    --fs-0: 1rem;
    --gr-0: 1.6rem;
    --fs-05: 1.118033988749895rem;
    --gr-05: 1.6rem;
    --fs-1: 1.25rem;
    --gr-1: 1.6rem;
    --fs-15: 1.3975424859373686rem;
    --gr-15: 1.6rem;
    --fs-2: 1.5625rem;
    --gr-2: 1.6rem;
    --fs-25: 1.7469281074217107rem;
    --gr-25: 3.2rem;
    --fs-3: 1.953125rem;
    --gr-3: 3.2rem;
    --fs-35: 2.1836601342771385rem;
    --gr-35: 3.2rem;
    --fs-4: 2.44140625rem;
    --gr-4: 3.2rem;
    --fs-45: 2.729575167846423rem;
    --gr-45: 3.2rem;
    --fs-5: 3.0517578125rem;
    --gr-5: 3.2rem;
    --fs-55: 3.4119689598080285rem;
    --gr-55: 4.800000000000001rem;
    --fs-6: 3.814697265625rem;
    --gr-6: 4.800000000000001rem;
    --fs-65: 4.264961199760036rem;
    --gr-65: 4.800000000000001rem;
    --fs-7: 4.76837158203125rem;
    --gr-7: 4.800000000000001rem;
    --fs-75: 5.331201499700045rem;
    --gr-75: 6.4rem;
    --fs-8: 5.9604644775390625rem;
    --gr-8: 6.4rem;
    --fs-85: 6.664001874625056rem;
    --gr-85: 8rem;
    --fs-9: 7.450580596923828rem;
    --gr-9: 8rem;
    --fs-95: 8.33000234328132rem;
    --gr-95: 9.600000000000001rem;
    --fs-10: 9.313225746154785rem;
    --gr-10: 9.600000000000001rem;
  }

  // Small Desktop
  @include mq($from: ds) {
    font-size: 106.25%;
    --fs: 1.0625rem;
    --lh: 1.5;
    --s: 1.2;
    --fs--5: 0.40187757201646096rem;
    --gr--5: 1.5rem;
    --fs--45: 0.44023482309764517rem;
    --gr--45: 1.5rem;
    --fs--4: 0.4822530864197532rem;
    --gr--4: 1.5rem;
    --fs--35: 0.5282817877171742rem;
    --gr--35: 1.5rem;
    --fs--3: 0.5787037037037037rem;
    --gr--3: 1.5rem;
    --fs--25: 0.633938145260609rem;
    --gr--25: 1.5rem;
    --fs--2: 0.6944444444444445rem;
    --gr--2: 1.5rem;
    --fs--15: 0.7607257743127307rem;
    --gr--15: 1.5rem;
    --fs--1: 0.8333333333333334rem;
    --gr--1: 1.5rem;
    --fs--05: 0.9128709291752769rem;
    --gr--05: 1.5rem;
    --fs-0: 1rem;
    --gr-0: 1.5rem;
    --fs-05: 1.0954451150103321rem;
    --gr-05: 1.5rem;
    --fs-1: 1.2rem;
    --gr-1: 1.5rem;
    --fs-15: 1.3145341380123985rem;
    --gr-15: 1.5rem;
    --fs-2: 1.44rem;
    --gr-2: 1.5rem;
    --fs-25: 1.5774409656148782rem;
    --gr-25: 3rem;
    --fs-3: 1.7279999999999998rem;
    --gr-3: 3rem;
    --fs-35: 1.8929291587378538rem;
    --gr-35: 3rem;
    --fs-4: 2.0736rem;
    --gr-4: 3rem;
    --fs-45: 2.2715149904854246rem;
    --gr-45: 3rem;
    --fs-5: 2.4883199999999994rem;
    --gr-5: 3rem;
    --fs-55: 2.7258179885825093rem;
    --gr-55: 3rem;
    --fs-6: 2.9859839999999993rem;
    --gr-6: 3rem;
    --fs-65: 3.270981586299011rem;
    --gr-65: 4.5rem;
    --fs-7: 3.583180799999999rem;
    --gr-7: 4.5rem;
    --fs-75: 3.9251779035588132rem;
    --gr-75: 4.5rem;
    --fs-8: 4.2998169599999985rem;
    --gr-8: 4.5rem;
    --fs-85: 4.710213484270575rem;
    --gr-85: 6rem;
    --fs-9: 5.1597803519999985rem;
    --gr-9: 6rem;
    --fs-95: 5.65225618112469rem;
    --gr-95: 6rem;
    --fs-10: 6.191736422399997rem;
    --gr-10: 7.5rem;
  }

  // Desktop
  @include mq($from: dmx) {
    font-size: 112.5%;
    --fs: 1.125rem;
    --lh: 1.6;
    --s: 1.2;
    --fs--5: 0.40187757201646096rem;
    --gr--5: 1.6rem;
    --fs--45: 0.44023482309764517rem;
    --gr--45: 1.6rem;
    --fs--4: 0.4822530864197532rem;
    --gr--4: 1.6rem;
    --fs--35: 0.5282817877171742rem;
    --gr--35: 1.6rem;
    --fs--3: 0.5787037037037037rem;
    --gr--3: 1.6rem;
    --fs--25: 0.633938145260609rem;
    --gr--25: 1.6rem;
    --fs--2: 0.6944444444444445rem;
    --gr--2: 1.6rem;
    --fs--15: 0.7607257743127307rem;
    --gr--15: 1.6rem;
    --fs--1: 0.8333333333333334rem;
    --gr--1: 1.6rem;
    --fs--05: 0.9128709291752769rem;
    --gr--05: 1.6rem;
    --fs-0: 1rem;
    --gr-0: 1.6rem;
    --fs-05: 1.0954451150103321rem;
    --gr-05: 1.6rem;
    --fs-1: 1.2rem;
    --gr-1: 1.6rem;
    --fs-15: 1.3145341380123985rem;
    --gr-15: 1.6rem;
    --fs-2: 1.44rem;
    --gr-2: 1.6rem;
    --fs-25: 1.5774409656148782rem;
    --gr-25: 1.6rem;
    --fs-3: 1.7279999999999998rem;
    --gr-3: 3.2rem;
    --fs-35: 1.8929291587378538rem;
    --gr-35: 3.2rem;
    --fs-4: 2.0736rem;
    --gr-4: 3.2rem;
    --fs-45: 2.2715149904854246rem;
    --gr-45: 3.2rem;
    --fs-5: 2.4883199999999994rem;
    --gr-5: 3.2rem;
    --fs-55: 2.7258179885825093rem;
    --gr-55: 3.2rem;
    --fs-6: 2.9859839999999993rem;
    --gr-6: 3.2rem;
    --fs-65: 3.270981586299011rem;
    --gr-65: 4.800000000000001rem;
    --fs-7: 3.583180799999999rem;
    --gr-7: 4.800000000000001rem;
    --fs-75: 3.9251779035588132rem;
    --gr-75: 4.800000000000001rem;
    --fs-8: 4.2998169599999985rem;
    --gr-8: 4.800000000000001rem;
    --fs-85: 4.710213484270575rem;
    --gr-85: 4.800000000000001rem;
    --fs-9: 5.1597803519999985rem;
    --gr-9: 6.4rem;
    --fs-95: 5.65225618112469rem;
    --gr-95: 6.4rem;
    --fs-10: 6.191736422399997rem;
    --gr-10: 6.4rem;
  }
}

ul {
  list-style: none;

  li {
    list-style: none;
  }
}


.sec-header-bg-gradiant {
  height: 70%;
  background: linear-gradient(to bottom, rgba(0, 114, 181, 0.5), transparent);
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
}


// MapBox Popups
.mb-sec-popup {
  padding: gr(0.5) gr(0.5);

  display: grid;
  gap: gr(0.5) 0;

  * {
    outline: 0;
  }

  .sec-title {
    >div {
      color: #006e96;
    }
  }

  .sec-details {
    * {
      color: var(--heading-primary);
    }

    >.sec-detail {
      display: flex;
      gap: 0 gr(0.5);

      >.detail {
        >a {
          color: var(--heading-primary);
          font-size: fs(-1);
          line-height: gr(0);
          transition: all 0.1s ease;

          outline: 0;

          &:hover {
            color: #0093c9;
          }
        }
      }
    }
  }

  &.regional {
    padding: gr(0.25) gr(0.5);

    .sec-title {
      >div {
        color: #006e96;
        font-weight: 500;
        font-size: fs(0.5);
      }
    }
  }
}

.mapboxgl-popup-close-button {
  padding: 0 gr(0.25);
  outline: 0;
}

// Header Styles


// Global Styles

// Titles
.a-title {
  &.sticky-title {
    .a-title-primary {
      // font-weight: 300;
    }
  }
}



// Global components FOR NOW




.sec-cards-directory {



  .col-sticky-title {

    position: relative;

    padding-top: gr(0);

    // checkpoint
    :deep(.a-checkpoint) {
      position: absolute;
      top: 0;
      left: 0;
      transform: translate(-25%, -50%);
    }

    .m-wrap {
      position: relative;
    }

    .sticky-container {
      position: sticky;
      top: gr(3);
    }

    .sec-features-title {

      padding-left: gr(4);

      .a-title-primary {
        font-size: fs(5);
      }

      .a-title-subtitle {
        font-size: fs(1);
        line-height: gr(1.5);
      }
    }
  }

  .col-directory {
    .m-wrap {
      display: grid;
    }
  }

  &.title-left {}

  &.title-right {

    .col-sticky-title {

      :deep(.a-checkpoint) {
        position: absolute;
        top: 0;
        left: auto;
        right: gr(2);
        transform: translate(0, -120%);
      }

      .sec-features-title {
        padding-left: gr(1);
      }
    }


  }
}


.sec-benefits-title {
  padding: gr(1);
  background: rgba(255, 255, 255, 0.95);
  mix-blend-mode: overlay;
  border: 1px solid var(--base-500);

  .a-title-subtitle {}
}


// Generic Problem solution component


.sec-contact-form {

  position: relative;

  padding-top: gr(5);

  @include mq($until: t) {
    padding-top: gr(10);
  }

  :deep(.a-title) {
    @include mq($until: t) {
      padding-top: gr(2);
    }
  }

  :deep(.a-checkpoint) {
    position: absolute;
    top: 0;
    left: 0;
    transform: translate(-100%, 0%);

    @include mq($until: t) {
      transform: translate(25%, -125%);
    }
  }
}



.sec-contact-details {
  display: grid;
  gap: gr(1.5);

  .sec-detail {
    display: grid;
    grid-template-columns: gr(2) 1fr;
    gap: gr(1);

    >.icon {
      display: flex;
      justify-content: center;
      align-items: flex-start;

      .inner {
        width: gr(2);
        height: gr(2);
        border-radius: 50%;
        background: var(--base-100);
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all 0.1s ease;

        i {
          font-size: fs(2);
          color: var(--base-600);
          width: gr(0.75);
        }
      }
    }

    >.detail {
      display: grid;
      gap: gr(0.25);

      .title {
        font-size: fs(-1);
        font-weight: 600;
        color: var(--base-800);
      }

      .value {
        font-size: fs(-1);
        font-weight: 400;
        color: var(--base-700);

        a {
          color: inherit;
          text-decoration: none;
        }
      }
    }

    &:hover {
      .icon {
        .inner {
          transform: scale(1.1);
          background: var(--base-100);

          i {
            color: var(--blue-500);
          }
        }
      }

      .detail {
        .title {
          color: var(--blue-500);
        }
      }

    }
  }

}

.sec-socials {
  display: flex;
  flex-direction: column;
  grid-template-columns: repeat(4, 1fr);
  gap: gr(0.25);

  >.sec-title {
    display: none;

    .small {
      font-size: fs(0);
      font-weight: 300;
      color: var(--base-600);
      margin-bottom: gr(0.25);
    }
  }

  >.sec-icons {

    display: flex;
    grid-template-columns: repeat(4, 1fr);
    gap: gr(1);

    >.social {
      display: flex;
      justify-content: center;
      align-items: center;

      a {
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all 0.1s ease;

        i {
          font-size: fs(1);
          color: var(--base-600);
        }
      }

      &:hover {
        a {
          i {
            color: var(--blue-500);
          }
        }
      }
    }
  }

}


.sec-contact-row {
  &.duo-rows {}
}


.sticky-container {
  position: sticky !important;
}

.sec-features-title {
  .a-title-primary {
    font-size: fs(4);
    font-weight: 400;
  }

  .a-title-subtitle {
    font-size: fs(1);
    font-weight: 300;

  }
}

.sec-offerings-select {
  display: flex;
  justify-content: center;

  // padding-top: gr(2);


  :deep(.p-togglebutton) {

    background: white !important;
    border-color: var(--base-500);
    color: var(--base-600);

    * {
      transition: all 0s ease;
    }

    &.p-togglebutton-checked {

      &:before {
        background: var(--c-sky-blue) !important;
        color: white !important;
      }

      .p-togglebutton-content {
        color: white;
      }

    }

    &:hover {
      &:before {
        background: var(--c-sky-blue);
      }

      .p-togglebutton-content {
        color: white;
      }
    }
  }
}


.sec-features-title {

  .a-title-subtitle {
    font-size: fs(0) !important;
    font-weight: 300;
    color: var(--base-650) !important;
    line-height: gr(1.1125) !important;
  }
}


.sec-image-grid {
  .grid-image {
    width: 100%;
    aspect-ratio: 1 / 1;
  }
}






.sec-products-select-filter {
  // background: red;

  .p-multiselect {
    background: white;
    border-color: var(--base-500);

    .p-multiselect-label-container {
      .p-multiselect-label {
        color: var(--base-650);
        font-size: 17px;
      }
    }


    .p-multiselect-dropdown {
      svg {
        width: 14px;
        height: 14px;
      }
    }

    .p-multiselect-overlay {
      background: white;
      border-color: var(--base-400);

      .p-multiselect-list-container {
        ul.p-multiselect-list {
          li.p-multiselect-option {
            color: var(--base-600);
            margin-bottom: 0;

            background: white;

            font-size: fs(-0.5);

            &:hover {
              background: var(--base-100);
            }

            .p-checkbox {
              .p-checkbox-input {}

              .p-checkbox-box {
                display: flex;
                justify-content: center;
                align-items: center;
                // border-radius: var(--p-checkbox-border-radius);
                // border: 1px solid var(--p-checkbox-border-color);
                // background: var(--p-checkbox-background);
                // width: var(--p-checkbox-width);
                // height: var(--p-checkbox-height);
                // transition: background var(--p-checkbox-transition-duration), color var(--p-checkbox-transition-duration), border-color var(--p-checkbox-transition-duration), box-shadow var(--p-checkbox-transition-duration), outline-color var(--p-checkbox-transition-duration);
                // outline-color: transparent;
                // box-shadow: var(--p-checkbox-shadow);

                border-color: var(--base-500);
                background: white !important;
                // box-shadow: inset 0 0 0 1px red;

                svg {
                  * {
                    fill: var(--blue-500);
                  }
                }
              }

              &.p-checkbox-checked {}
            }

            >span {
              color: var(--base-650);
            }

            &[data-p-selected="true"] {

              // background: var(--base-100);
              >span {
                color: var(--base-700);
              }

            }
          }
        }
      }
    }


    .p-inputwrapper-focus {}

    .p-multiselect-open {}

    &:hover {
      border-color: var(--c-sky-blue) !important;

      .p-multiselect-label-container {
        .p-multiselect-label {
          color: var(--base-650);
        }
      }
    }
  }
}


.test-enter-from {
  opacity: 0;
}

.test-enter-to {
  opacity: 1;
}

.test-enter-active {
  transition: all 2s ease;
}

.test-leave-from {
  opacity: 1;
}

.test-leave-to {
  opacity: 0;
}

.test-leave-active {
  transition: all 2s ease;
}




.herooverlay-enter-from {
  opacity: 0;
}

.herooverlay-enter-to {
  opacity: 1;
}

.herooverlay-enter-active {
  transition: all 5s ease;
}

.herooverlay-leave-from {
  opacity: 1;

}

.herooverlay-leave-to {
  opacity: 0;
}

.herooverlay-leave-active {
  transition: all 5s ease;
}





.io-header {
  .sec-mobile-navigation {
    transition: all 0.2s ease;
    border-color: transparent;
    .sec-flyout-menu {
      .sec-navigation-wrapper {
        .sec-header-branding {
          .m-wrap {
            button.sec-logo {
              position: relative;
              transform: none;
              height: auto;

              .logo {
                display: flex;
                justify-content: center;

                img {
                  height: 44px;
                }
              }
            }
          }
        }
      }
    }
  }

  &.header-fixed {
    .sec-mobile-navigation {
      background:white;
      border-color: white;
    }
  }
}


// Global Styles


.sec-problem-solution {
  .a-title-problem {
    .a-title-primary {
      font-weight: 400;
    }
  }
}

.sec-features-title {
  .a-title-subtitle {
    font-weight: 400 !important;
    color: var(--base-600) !important;
    line-height: gr(1.25) !important;
  }
}

.service-page {

}

button {
  border: 0;
  background: transparent;
  cursor: pointer;
}

.p-overlay-mask {
  background: rgba(0, 0, 0, 0.4);
  color: #e2e8f0;
}
.p-image-toolbar {
    position: absolute;
    inset-block-start: 1rem !important;
    inset-inline-end: 1rem !important;
    inset-inline-start: auto !important;
    inset-block-end: auto !important;
    display: flex !important;
    z-index: 1 !important;
    padding: 0.5rem !important;
    background: rgba(255, 255, 255, 0.1) !important;
    backdrop-filter: blur(8px) !important;
    border-color: rgba(255, 255, 255, 0.2) !important;
    border-style: solid !important;
    border-width: 1px !important;
    border-radius: 30px !important;
    gap: 0.5rem !important;
}
.p-image-preview-mask {
  position: absolute !important;
  inset-inline-start: 0 !important;
  inset-block-start: 0 !important;
  width: 100% !important;
  height: 100% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  opacity: 0 !important;
  transition: opacity 0.3s !important;
  border: 0 none !important;
  padding: 0 !important;
  cursor: pointer !important;
  background: transparent !important;
  color: #e2e8f0 !important;
  transition: background 0.3s !important;

  max-height: 600px !important;

  svg {
    width: 24px !important;
    height: 24px !important;
    * {
      fill: #e2e8f0 !important;
    }
  }
}

.mpd-selectbutton {

}
</style>